import { jsx } from "react/jsx-runtime";
import { useSuggestedQueries } from "../../api/cache/appConfigQueryOptions.js";
import { useStudioAvailability, useStudioVoiceSkills, useStudioVoiceBranding } from "@brandclub/bc-widgets";
import { memo, useCallback, useMemo } from "react";
import { ConciergeWelcomeFullPage } from "./ConciergeWelcomeFullPage.js";
import { ConciergeWelcomeEmbedded } from "./ConciergeWelcomeEmbedded.js";
import { usePageContext } from "../hooks/usePageContext.js";
import { useConciergeContext } from "../ConciergeContextProvider.js";
const ConciergeWelcomeComponent = ({
  trendingSearches,
  onSearch,
  brandId,
  isEmbedded = false,
  apiBaseUrl,
  userFirstName,
  pageContext: providedPageContext,
  brandLogoUrl,
  brandName,
  conciergeName,
  searchInputValue,
  setSearchInputValue,
  handleSearch,
  isActivelyStreaming,
  isMobile
}) => {
  const { data, isLoading: isLoadingSuggestedQueries } = useSuggestedQueries(brandId, apiBaseUrl);
  const studioAvailability = useStudioAvailability();
  const voiceSkills = useStudioVoiceSkills();
  const voiceBranding = useStudioVoiceBranding();
  const { openVoiceCall } = useConciergeContext();
  const handleVoiceCallClick = useCallback(() => {
    openVoiceCall();
  }, [openVoiceCall]);
  const suggestedQueries = useMemo(
    () => (data == null ? void 0 : data.suggestedQuestions) || (trendingSearches == null ? void 0 : trendingSearches.map((search) => ({ query: search.text, imageUrl: "" }))) || [],
    [data == null ? void 0 : data.suggestedQuestions, trendingSearches]
  );
  const displayQueries = useMemo(() => {
    var _a;
    if ((studioAvailability == null ? void 0 : studioAvailability.searchPrompts) === false) return [];
    const studioPrompts = (_a = studioAvailability == null ? void 0 : studioAvailability.defaultSearchPrompts) == null ? void 0 : _a.filter((t) => t.trim());
    if (studioPrompts == null ? void 0 : studioPrompts.length) return studioPrompts;
    return suggestedQueries.map((item) => item.query);
  }, [suggestedQueries, studioAvailability]);
  const hookPageContext = usePageContext();
  const pageContext = providedPageContext ?? hookPageContext;
  const commonProps = {
    displayQueries,
    isLoadingSuggestedQueries,
    onSearch,
    pageContext,
    apiBaseUrl,
    brandLogoUrl,
    brandName,
    userName: userFirstName,
    conciergeName,
    searchInputValue,
    setSearchInputValue,
    handleSearch,
    isActivelyStreaming,
    isMobile
  };
  if (isEmbedded) {
    return /* @__PURE__ */ jsx(ConciergeWelcomeEmbedded, { ...commonProps });
  }
  return /* @__PURE__ */ jsx(
    ConciergeWelcomeFullPage,
    {
      ...commonProps,
      voiceCallEnabled: voiceSkills.enabled,
      onVoiceCallClick: handleVoiceCallClick,
      voiceAssistantName: voiceBranding.persona.assistantName
    }
  );
};
const ConciergeWelcome = memo(ConciergeWelcomeComponent);
export {
  ConciergeWelcome as default
};
//# sourceMappingURL=ConciergeWelcome.js.map
